<template>
  <div class="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-50 to-gray-100">
    <div class="text-center max-w-md mx-auto px-6">
      <!-- Icon -->
      <div class="text-indigo-500 mb-6">
        <svg class="w-20 h-20 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"></path>
        </svg>
      </div>
      
      <!-- Title -->
      <h1 class="text-3xl font-bold text-gray-900 mb-4">
        Inloggning krävs
      </h1>
      
      <!-- Message -->
      <p class="text-lg text-gray-600 mb-8">
        {{ message || 'Du behöver logga in för att komma åt denna sida.' }}
      </p>
      
      <!-- Action Buttons -->
      <div class="space-y-4">
        <router-link 
          to="/login"
          class="inline-block w-full bg-indigo-600 text-white px-6 py-3 rounded-lg hover:bg-indigo-700 transition-colors font-medium text-lg"
        >
          Logga in
        </router-link>
        
        <router-link 
          to="/register"
          class="inline-block w-full bg-gray-600 text-white px-6 py-3 rounded-lg hover:bg-gray-700 transition-colors font-medium text-lg"
        >
          Skapa konto
        </router-link>
        
        <router-link 
          to="/"
          class="inline-block w-full bg-white text-gray-700 px-6 py-3 rounded-lg border border-gray-300 hover:bg-gray-50 transition-colors font-medium"
        >
          Tillbaka till startsidan
        </router-link>
      </div>
      
      <!-- Additional Info -->
      <div class="mt-8 p-4 bg-blue-50 rounded-lg">
        <p class="text-sm text-blue-700">
          <strong>Tips:</strong> Om du redan har ett konto, använd "Logga in". 
          Är du ny användare? Skapa ett konto med "Skapa konto".
        </p>
      </div>
    </div>
  </div>
</template>

<script setup>

import defineProps from 'vue';
defineProps({
  message: {
    type: String,
    default: ''
  }
});
</script>
